export enum AtiraLinkReportReasons {
  INAPPROPRIATE_CONTENT = 'INAPPROPRIATE_CONTENT',
  IDENTITY_THEFT = 'IDENTITY_THEFT',
  FRAUD = 'FRAUD',
  HARASSMENT = 'HARASSMENT',
  HATE_SPEECH = 'HATE_SPEECH',
  OTHER = 'OTHER',
}
